import { render, staticRenderFns } from "./client-footer.component.vue?vue&type=template&id=eb2db24e&scoped=true"
import script from "./client-footer.component.ts?vue&type=script&lang=ts&external"
export * from "./client-footer.component.ts?vue&type=script&lang=ts&external"
import style0 from "./client-footer.component.vue?vue&type=style&index=0&id=eb2db24e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2db24e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb2db24e')) {
      api.createRecord('eb2db24e', component.options)
    } else {
      api.reload('eb2db24e', component.options)
    }
    module.hot.accept("./client-footer.component.vue?vue&type=template&id=eb2db24e&scoped=true", function () {
      api.rerender('eb2db24e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/client-footer/client-footer.component.vue"
export default component.exports